// i18n area 'networks' — locale sk-SK (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/networks.sk-SK.meta.json.
import type { enUS } from './networks'

export const skSK: typeof enUS = {
  networks: {
    common: {
      name: 'Názov',
      scope: 'Scope',
      operState: 'Stav',
      actions: 'Akcie',
      create: 'Vytvoriť',
      close: 'Zavrieť',
      cancel: 'Zrušiť',
      delete: 'Odstrániť',
      edit: 'Upraviť',
      save: 'Uložiť',
      editError: 'Úprava zlyhala',
      search: 'Hľadať podľa názvu',
      empty: 'Zatiaľ tu nič nie je',
      saveError: 'Nepodarilo sa uložiť',
      loadError: 'Nepodarilo sa načítať — je backend TVirt dostupný?',
      createError: 'Vytvorenie zlyhalo',
      deleteError: 'Odstránenie zlyhalo',
      deleteConfirmTitle: 'Odstrániť {name}?',
      deleteConfirmBody: 'Táto operácia sa nedá vrátiť späť.',
      nameHint: 'Malé písmená, číslice a pomlčky (DNS-1123)',
      up: 'Aktívna',
      down: 'Neaktívna',
      unknown: 'Neznámy',
      usedByVMs: 'VM',
      emptyTable: 'Žiadne položky — pridajte jednu tlačidlom +'
    },
    dialogTabs: {
      general: 'Všeobecné',
      base: 'Základná definícia',
      advanced: 'Pokročilá konfigurácia',
      reserved: 'Rozsahy rezervované pre TVirt',
      position: 'Pozícia',
      network: 'Konfigurácia siete',
      hosts: 'Zúčastnené uzly'
    },
    reservedRanges: {
      note: 'Toto sú rozsahy IP rezervované pre TVirt, ktoré môže používať na automatické priradenie adresy VM, kontajnerom atď. POZNÁMKA: IP z týchto rozsahov sa mimo TVirt nesmú používať externými službami či zariadeniami.',
      from: 'Od',
      to: 'Do'
    },
    overlay: {
      title: 'Overlay siete',
      createTitle: 'Vytvoriť overlay sieť',
      editTitle: 'Upraviť overlay sieť',
      vni: 'VNI',
      vniHint: 'VXLAN Network Identifier — ak je prázdny, priradí sa automaticky',
      subnet: 'Podsieť',
      subnetHint: 'CIDR overlay siete — IPAM z neho automaticky odvodí položku registra',
      mtu: 'MTU',
      weight: 'Váha',
      ceilMbps: 'Strop (Mbps)',
      fairnessHint: 'Váha sa uplatní len pri súbehu: na voľnej linke môže každá sieť využiť celú šírku pásma. Strop však platí vždy.',
      contention: 'Súperenie',
      contentionTip: 'Aspoň jeden uzol pozoruje zahadzovanie alebo overlimity S frontom na triede tejto siete: pásmo uplinku je pod tlakom a váhy pôsobia. Koľko a odkedy hovoria rady net.shaping.* uzla.',
      firewallPolicy: 'Politika firewallu',
      hosts: 'Hostitelia',
      hostsTitle: 'Zúčastnené uzly',
      hostsHint: 'Každý uzol deklaruje svoj underlay endpoint — výber zo SKUTOČNÝCH adries uzla, načítaných z jeho sieťovej konfigurácie; voliteľná overlay adresa musí ležať v podsieti. Účasť predstavuje obmedzenie placementu.',
      hostNode: 'Uzol',
      hostUnderlay: 'Underlay IP',
      hostUnderlayPickNode: 'Najprv vyberte uzol',
      hostAddress: 'Adresa v overlay sieti (voliteľná)',
      hostAddressOutside: 'Mimo subnetu overlayu ({cidr})',
      addHost: 'Pridať uzol',

      // Round #156 (dialog standard): le righe osservate del dialog dettagli.
      observedAt: 'Pozorované dňa',
      attachedNics: 'Pripojené NIC'
    },
    services: {
      title: 'Sieťové služby',
      createTitle: 'Vytvoriť sieťovú službu',
      editTitle: 'Upraviť sieťovú službu',
      kind: 'Typ',
      kindCategory: 'Služby',
      selectKindHint: 'Vyberte typ služby — démon pod ňou je implementačný detail, ktorý TVirt spravuje za vás.',
      kindLabel: {
        dhcp: 'DHCP server',
        ntp: 'NTP server',
        vpn: 'VPN server',
        dns: 'DNS server',
        gateway: 'Brána',
        'lb-rp': 'Load balancer a reverse proxy',
        floatip: 'Plávajúca IP'
      },
      kindDesc: {
        dhcp: 'Prideľuje adresy na obsluhovaných podsieťach — pooly sa odvodzujú z podsiete, brány a rozsahov rezervovaných pre TVirt danej siete.',
        dns: 'Autoritatívny DNS nad deklarovanými zónami — záznamy sa odvodzujú z IPAM, plus vaše manuálne.',
        gateway: 'Uzol slúži ako brána pre sieť — NAT (DNAT, 1:1, SNAT/masquerade) plus statické smerovanie medzi pripojenými sieťami, samoopravné už z návrhu.',
        'lb-rp': 'Load balancer / reverzný proxy pred vašimi službami — L4 alebo L7 listenery nad poolmi členov alebo nad pripravenými inštanciami Podu, prekonfigurované za behu.',
        ntp: 'Časová služba pre siete — relay externých upstream serverov, alebo hodiny uzla poskytované klientom.',
        vpn: 'VPN koncentrátor na uzle — WireGuard alebo OpenVPN, výber je na vás: vzdialený prístup pre roamujúcich klientov, alebo tunel site to site medzi dvoma sieťami.',
        floatip: 'Jedna adresa, ktorá sedí vždy len na jednej zdravej inštancii App alebo Pode a presunie sa na ďalší zdravý cieľ, keď ten padne — failover bez démonov; vyvažovanie zostáva load balanceru.'
      },

      // Round Pod nativi P4: l'IP flottante (4b) e il backend Pod dell'lb-rp (4a).
      floatip: {
        hint: 'Plávajúca IP žije vo zvolenej sieti ako ĎALŠIA adresa v mennom priestore držiacej inštancie: žiadne porty, žiadne vyvažovanie, žiadny NAT — IP klienta zostáva pravá.',
        address: 'Plávajúca IP',
        targets: 'Ciele',
        targetsHint: 'V poradí PREFERENCIE: prvý zdravý cieľ drží adresu. Pod znamená všetky jeho inštancie po replikách; každý cieľ má vlastné kritérium zdravia. Každý cieľ musí byť pripojený k rovnakej sieti.',
        targetKind: 'Cieľ',
        targetApp: 'Inštancia App',
        targetPod: 'Pod (všetky inštancie)',
        targetRef: 'Ktorý',
        health: 'Zdravie',
        healthRunning: 'Beží (každý kontajner pripravený)',
        healthTcp: 'TCP pripojenie',
        healthHttp: 'HTTP GET',
        healthPing: 'Ping',
        port: 'Port',
        path: 'Cesta',
        addTarget: 'Pridať cieľ',
        moveUp: 'Posunúť vyššie',
        moveDown: 'Posunúť nižšie',
        preempt: 'Preempt',
        preemptHint: 'Vypnuté (predvolené): zdravý držiteľ si adresu ponechá, aj keď sa vráti vyšší cieľ — žiadne prepínanie. Zapnuté: adresu vždy drží prvý zdravý cieľ.',
        holder: 'Držiteľ',
        noHolder: 'žiadny zdravý cieľ',
        since: 'od',
        verdicts: 'Pozorované ciele',
        healthy: 'zdravý',
        unhealthy: 'nezdravý',
        noVerdict: 'Zatiaľ nerozhodnuté — autoritatívny uzol zapíše prvý verdikt pri ďalšom prechode.',
        vipChip: 'VIP {address}',
        vipChipTooltip: 'Táto inštancia drží plávajúcu IP {address} služby {service}'
      },
      poolSource: 'Endpointy',
      poolSourceMembers: 'Statickí členovia',
      poolSourcePod: 'Pripravené inštancie Podu',
      poolBackendPod: 'Pod',
      poolBackendPort: 'Port',
      poolBackendHint: 'Endpointy nasledujú Pod: inštancia vstúpi, keď beží s každým kontajnerom pripraveným, a hneď odíde, keď je zmenšená alebo zomrie. Aktívna kontrola je predvolene zapnutá.',
      poolBackendCount: 'pripravené inštancie Podu {pod} na porte {port}',
      node: 'Uzol',
      enabled: 'Povolené',
      parked: 'Zaparkované',
      subnets: 'Podsiete',
      subnetsHint: 'Podsiete IPAM obsluhované touto inštanciou — pooly sa odvodzujú z CIDR, brány a rozsahov rezervovaných pre TVirt',
      noSubnets: 'Žiadne podsiete IPAM — najprv deklarujte logickú sieť fabric (alebo overlay podsieť): IPAM sa odvodzuje z nich',
      iface: 'Počúvacie rozhranie',
      ifaceHint: 'Rozhranie hostiteľa, na ktorom služba otvára svoj socket (napr. bridge) — povinné: sieťová služba je sebestačná, „všetky rozhrania“ už neexistujú',
      dns: 'DNS servery',
      domain: 'Doména',
      detail: 'Obsluhuje',
      subnetCount: 'podsiete: {n}',
      zones: 'Zóny',
      zonesHint: 'Len autoritatívne — démon nikdy nerekurzuje. Záznamy A sa odvodzujú z deklarovaných adries uzlov v referencovaných podsieťach IPAM; prepínač reverse obsluhuje aj zodpovedajúce zóny in-addr.arpa (PTR). Jednu zónu obsluhuje najviac jedna inštancia DNS v celej flotile. Voliteľný nameserver je FQDN zapísaný v záznamoch NS/SOA namiesto predvoleného ns.<zóna>; ak padne dovnútra zóny, jeho záznam A sa aj tak odvodí z obsluhujúceho uzla.',
      zoneName: 'Názov zóny',
      zoneNs: 'Nameserver (NS)',
      zoneSubnets: 'Podsiete IPAM',
      zoneReverse: 'Reverse (PTR)',
      zoneRecords: 'Manuálne záznamy',
      zoneRecordsHint: 'Jeden na riadok: názov TYP hodnota — typy A, CNAME, MX, TXT. Pri kolízii názvov vyhráva manuálny záznam nad odvodeným.',
      addZone: 'Pridať zónu',

      // lb-rp (wave 3 fondamenta): listener su pool inline — engine-less,
      // riconfigurato in volo.
      lbListeningHint: 'Inštancia deklaruje JEDNU počúvaciu sieť a JEDNU adresu — každý listener si ju viaže na vlastnom porte; druhá adresa je druhá služba.',
      listeners: 'Listenery',
      listenersHint: 'Každý listener viaže adresu inštancie na vlastnom porte v režime L4 (TCP passthrough — bajty sa nikdy neotvárajú) alebo L7 (HTTP) a preposiela na jeden z poolov nižšie. Dvojicu adresa/port obsluhuje najviac jedna inštancia na uzol. Zmeny sa aplikujú za behu — žiadny reštart, žiadne stratené spojenia.',
      listenerName: 'Názov',
      listenerMode: 'Režim',
      modeL7: 'L7 — HTTP reverse proxy',
      modeL4: 'L4 — TCP passthrough',
      listenerPort: 'Port',
      listenerPool: 'Pool',
      addListener: 'Pridať listener',
      pools: 'Pooly',
      poolsHint: 'Backendy, na ktorých pristáva prevádzka: statické členy vyvažované round-robin alebo podľa najmenšej vyťaženosti, s voliteľným aktívnym health checkom, ktorý choré členy vyraďuje z rotácie.',
      poolName: 'Názov',
      poolAlgorithm: 'Algoritmus',
      algoRoundRobin: 'Round robin',
      algoLeastRequest: 'Najmenej vyťažený',
      poolCheck: 'Health check',
      checkNone: 'Žiadny',
      checkTcp: 'Spojenie TCP',
      checkHttp: 'HTTP',
      poolCheckPath: 'Cesta sondy',
      poolInterval: 'Interval (s)',
      poolMembers: 'Členy',
      poolMembersHint: 'Jeden na riadok: adresa:port, voliteľne nasledovaný váhou (1-128) — napr. 10.0.0.21:8080 2',
      addPool: 'Pridať pool',
      memberCount: 'členov: {n}',

      // ntp (round ntp — ratifica 2026-08-03, l'ultimo kind della famiglia):
      // il modo in parole parlate, la lista upstream solo dove significa
      // qualcosa, l'attacco di rete riusa le etichette del gateway.
      // #239 (netsvc autocontenuti): l'editor condiviso della lista di
      // listener dei kind dns e ntp — le due eccezioni multi-rete ratificate.
      listen: {
        assignment: 'Pridelenie',
        assignmentStatic: 'Statická adresa',
        assignmentAuto: 'Automatické (rezervované rozsahy TVirt)',
        autoHint: 'TVirt vytiahne adresu z rezervovaných rozsahov logickej siete a drží ju sticky — nikdy znovu neťahaná pri editácii ani failoveri.',
        title: 'Listenery',
        hint: 'Sieťová služba je sebestačná: každý listener deklaruje svoju sieť (overlay, logickú sieť fabric alebo rozhranie) a adresu vo vnútri jej podsiete — jeden listener na adresu, wildcard už neexistuje. DNS a NTP môžu počúvať na viacerých sieťach a viacerých adresách týchto sietí.',
        address: 'Počúvacia adresa',
        add: 'Pridať listener'
      },
      ntp: {
        mode: 'Režim synchronizácie',
        modeRelay: 'Relay externých serverov',
        modeNodeClock: 'Hodiny uzla',
        modeHint: 'Relay poskytuje čas prevzatý z deklarovaných upstream serverov; hodiny uzla poskytujú čas obsluhujúceho uzla — ktorý klaster aj tak drží synchronizovaný',
        servers: 'Upstream servery',
        serversHint: 'Oddelené čiarkami — hostname alebo IP adresa; služba odtiaľto berie čas a poskytuje ho sieti',
        port: 'Počúvací port',
        listening: 'Počúva na'
      },

      vpn: {
        engine: 'Engine',
        engineHint: 'Vyberáte si ho vy a už sa nemení: WireGuard je moderný, rýchly a beží v kerneli; OpenVPN je veterán kompatibility (TCP, nepriateľské siete)',
        engineLocked: 'Engine je nemenný — iný engine je nová služba, kľúče a certifikáty nie sú prenosné',
        mode: 'Režim',
        modeRemote: 'Vzdialený prístup',
        modeSite: 'Site to site',
        modeHint: 'Vzdialený prístup dáva roamujúcim klientom adresu v tuneli; site to site spája dve siete',
        port: 'Počúvací port',
        protocol: 'Transport',
        protocolWireguardHint: 'WireGuard hovorí iba UDP',
        tunnelSubnet: 'Podsieť tunela',
        tunnelSubnetHint: 'Sieť, v ktorej žijú klienti — zapísaná v registri IPAM, vzniká a zaniká s touto službou',
        dnsServers: 'DNS tlačené klientom',
        routes: 'Trasy tlačené klientom',
        routesHint: 'Siete oddelené čiarkami dosiahnuteľné cez tunel; podsieť tunela je vždy zahrnutá',
        peers: 'Peery',
        peersHint: 'Nechajte verejný kľúč prázdny a TVirt vygeneruje pár — potom ho odovzdá s profilom. Vložte kľúč a peer si ponechá svoj.',
        clients: 'Klienti',
        clientsHint: 'Každý klient dostane certifikát vydaný vlastnou CA tejto služby. Odobratie klienta ho ODVOLÁ: CRL sa okamžite pregeneruje.',
        peerName: 'Názov',
        publicKey: 'Verejný kľúč',
        publicKeyMinted: 'Vygeneruje ho TVirt',
        peerAddress: 'Adresa v tuneli',
        peerAddressHint: 'Prázdne = pridelí sa',
        allowedIps: 'Vzdialené podsiete',
        allowedIpsHint: 'Oddelené čiarkami, smerované cez tento peer',
        endpoint: 'Endpoint',
        presharedKey: 'Vopred zdieľaný kľúč',
        keepalive: 'Keepalive (s)',
        addPeer: 'Pridať peer',
        addClient: 'Pridať klienta',
        auth: 'Autentifikácia',
        authTls: 'Certifikáty (TLS)',
        remote: 'Vzdialený endpoint',
        remoteHint: 'host:port vzdialeného konca — prázdne znamená, že táto strana čaká',
        peerRoutes: 'Vzdialené podsiete',
        serverPublicKey: 'Verejný kľúč tohto servera',
        ca: 'Certifikačná autorita',
        listening: 'Počúva na',
        tunnel: 'Tunel',
        peerCount: 'peerov: {n}',
        download: 'Stiahnuť profil',
        downloadError: 'Profil sa nepodarilo exportovať',
        lastHandshake: 'Posledný handshake',
        never: 'nikdy',
        traffic: '↓ {rx} · ↑ {tx}',
        connected: 'Pripojený',
        idle: 'Nečinný'
      },

      // Gateway (wave 3 — nato nat, ratifica 2026-08-01/02; rinominato ed
      // esteso il 2026-08-03): le tre famiglie di regole NAT più le rotte
      // statiche su una rete di listening. Ogni forma ratificata è supportata.
      gateway: {
        attach: 'Typ počúvacej siete',
        attachOverlay: 'Overlay sieť',
        attachNetwork: 'Logická sieť fabric',
        attachInterface: 'Holé rozhranie',
        overlay: 'Overlay sieť',
        network: 'Logická sieť',
        interface: 'Názov rozhrania',
        interfaceHint: 'Rozhranie hostiteľa, ktoré TVirt nespravuje — adresa sa prijíma bez overenia',
        address: 'Počúvacia adresa (brána)',
        addressHint: 'Adresa brány, na ktorú mieria klienti — vo vnútri podsiete počúvacej siete',
        dnatTitle: 'Pravidlá DNAT',
        dnatHint: 'Cieľový NAT: prevádzka zodpovedajúca pravidlu sa presmeruje na novú adresu (a voliteľne nový port). Ktorýkoľvek protokol zo zoznamu — porty tam, kde ich protokol nesie.',
        snatTitle: 'Pravidlá SNAT',
        snatHint: 'Zdrojový NAT: prevádzka zodpovedajúca pravidlu odchádza s prepísaným zdrojom — explicitná nová adresa (a voliteľne nový port), alebo masquerade na výstupnej adrese, ak ostane prázdne.',
        oneToOneTitle: 'Pravidlá 1:1 NAT',
        oneToOneHint: 'Každý paket pre externú adresu sa mapuje na internú a interný hostiteľ vychádza ako externý — všetky protokoly, oba smery.',
        external: 'Externá adresa',
        internal: 'Interná adresa',
        addOneToOne: 'Pridať pravidlo 1:1',
        family: 'Rodina',
        protocol: 'Protokol',
        source: 'Zdroj (adresa/podsieť)',
        destination: 'Cieľ (adresa/podsieť)',
        invert: 'NOT',
        srcPorts: 'Zdrojové porty',
        dstPorts: 'Cieľové porty',
        dstPortsHint: 'Port alebo rozsah (80, 8000-8099)',
        toAddress: 'Nová adresa',
        toPort: 'Nový port',
        snatTo: 'Nový zdroj (prázdne = masquerade)',
        snatToHint: 'Explicitná zdrojová adresa; prázdne = masquerade na výstupnej adrese',
        addDnat: 'Pridať pravidlo DNAT',
        addSnat: 'Pridať pravidlo SNAT',
        routesTitle: 'Statické trasy',
        routesHint: 'Uzol smeruje medzi sieťami, ku ktorým je pripojený (IP forwarding je zapnutý); tieto trasy pridávajú dosiahnuteľnosť nad ich rámec — čistý kernel, dynamické smerovanie príde v neskoršom kole.',
        routeDestination: 'Cieľová podsieť',
        routeGateway: 'Next hop',
        routeMetric: 'Metrika',
        addRoute: 'Pridať trasu',
        listening: 'Počúva na',
        rules: '{d} DNAT · {o} 1:1 · {s} SNAT · trasy: {r}'
      },
      unknownSince: 'Neznámy — posledný report pred {m} min',
      lastWord: 'Posledné slovo',

      // Round #156 (dialog standard): le righe osservate e il riepilogo in
      // sola lettura del blocco kind nel dialog dettagli.
      reportObservedAt: 'Posledný report',
      lastErrorRow: 'Posledná chyba',
      recordsCount: 'manuálnych záznamov: {n}',
      phase: {
        configured: 'Nakonfigurované',
        running: 'Beží',
        error: 'Chyba'
      },
      authorityNode: 'Authority (priradenie)',
      preferredNode: 'Preferovaný uzol',
      preferredNodeHint: 'Mäkká preferencia, nikdy obmedzenie: pri najbližšom rozhodnutí o placemente inštancia pristane tu, ak je tento člen spôsobilý — sama osebe nič nepresunie; ťahom je „Preniesť authority“.',
      noPreference: 'Žiadna preferencia (automatický placement)',
      moving: 'V pohybe',
      movingTooltip: 'Pozorovaná tu, zatiaľ čo authority priraďuje {node}: presun práve konverguje.',
      placement: {
        title: 'Placement',
        loading: 'Prebieha sčítanie…',
        loadError: 'Sčítanie placementu neodpovedalo — skúste to neskôr.',
        draftHint: 'Sčítanie sa počíta z deklarovaného pripojenia siete: objaví sa, len čo služba vznikne. Vytvorenie je odmietnuté, keď ju nemôže obslúžiť žiaden člen, a odmietnutie pomenuje mechanizmus, ktorý množinu vyprázdnil.',
        eligibleCount: '{n} z {m} členov môže obslúžiť túto inštanciu',
        recommended: 'Odporúčaný',
        eligible: 'Spôsobilý',
        notEligible: 'Nespôsobilý',
        blockedReachability: 'sieť k tomuto členovi nedosiahne',
        blockedRequireTag: 'blokovaný povinnou značkou (requireNodes)',
        blockedExcluded: 'vylúčený simuláciou',
        preferenceUnknown: 'nie je (už) členom klastra',
        preferenceIgnored: 'Preferencia „{node}“ dnes nie je spôsobilá: {reason}. Prednosť má odporúčanie sčítania — nikdy chyba, služba žije inde.',
        emptyReachability: 'Žiaden člen nemôže túto inštanciu obslúžiť: sieť nedosiahne nikam — žiadna úprava značiek nepomôže. Zapojte uzol káblom, alebo službu presuňte tam, kde sieť je.',
        emptyRequireTag: 'Žiaden člen nemôže túto inštanciu obslúžiť: množinu vyprázdnili povinné značky — odstráňte položku z requireNodes, alebo označte niektorého člena značkou.',
        spof: 'Jediný bod zlyhania',
        spofDetail: 'Inštanciu môže hostiť len jediný člen: pri zlyhaní nemá failover kam ísť. Služba s viacerými listenermi sa sťahuje ako CELOK — kandidát musí vidieť VŠETKY jej siete: to je tá cena.',
        whatIf: 'Simulovať neprítomných členov',
        whatIfHint: 'What-if drainu: spýtajte sa PRED evakuáciou, nech to neobjavíte až pri failoveri.',
        survives: 'Bez {nodes} má služba stále domov.',
        notSurvives: 'Evakuácia {nodes} nechá túto službu MIMO PREVÁDZKY: odvodené obmedzenie víťazí nad dostupnosťou (R30) — démon živý tam, kam sieť nedosiahne, nikomu neslúži a nikoho nealarmuje.',
        transfer: 'Preniesť authority',
        transferError: 'Prenos sa nepodaril',
        transferTarget: 'Cieľový člen',
        transferHint: 'Ponúkajú sa len spôsobilí členovia — preferencia vnútri platnej množiny, nikdy override. Žiadna úloha: najbližší prechod workerov JE ten presun (starý uzol žne, nový realizuje).'
      }
    },
    fabric: {
      tabDerivation: 'Derivácia',
      importNetwork: 'Importovať z iného fabricu',
      importTitle: 'Importovať logickú sieť',
      importHint: 'Import je výslovné pristúpenie: sieť zostáva vlastníkovi (rovnaká identita, rovnaký stem, rovnaký bridge tvf-<stem>) a odtiaľ sa mapuje na porty/LAGG tohto fabricu — mapovať ZNAMENÁ tvrdiť, že doručenie ústi do rovnakej L2 domény ako u vlastníka.',
      importPick: 'Sieť vlastníka',
      importNone: 'Nie je čo importovať: ostatné fabricy nemajú vlastnú sieť, ktorú by tento fabric už nepoznal',
      importedNetworksTitle: 'Importované siete',
      noImported: 'Žiadna importovaná sieť',
      importedFrom: 'importovaná z {fabric}',
      importedBy: 'Importovaná do: {list}',
      importedCount: '+{n} importovaných',
      owner: 'Vlastník',
      bridge: 'Bridge',
      bond: 'Bond',
      unimport: 'Odstrániť import',
      unimportConfirm: 'Odstrániť import siete {name} (vlastník {fabric}) z tohto fabricu? Odmieta sa, kým ju mapuje port alebo LAGG tohto fabricu, alebo je hosť, App či služba obsluhovaný len cez túto nohu.',
      unimportRefused: 'Import sa stále používa — {detail}',
      deriv: {
        codeHint: {
          deviceHeldByFabric: 'Tento uzol už túto sieť berie z iného fabricu, ktorého je členom: uzol berie zdieľanú sieť len JEDNOU zo svojich nôh (dva uplinky toho istého L2 v bridgi bez STP sú slučka). Odmapuj ju na portoch alebo LAGG jedného z dvoch fabricov.',
          otherFabricDerived: 'Dokument nesie blok fabricu, ku ktorému uzol už nedeklaruje kábel: najprv aplikuj plán toho fabricu (navrhuje odstránenie jeho zariadení), alebo ich prevezmi cez take-ownership, ak fabric už neexistuje.'
        },
        hint: 'Plán derivácie O.3: pre každý zakáblovaný uzol stav, diff odvodené-vs-aktuálne, DEKLAROVANÁ topológia bondov, dual-stack flipy a štruktúrované odmietnutia/varovania. Len na čítanie až po EXPLICITNÝ apply — nič nikdy nepristane na uzle samo.',
        refresh: 'Znovu načítať plán',
        empty: 'Žiadny uzol nie je k tejto fabric zakáblovaný (a žiadny už nenesie jej blok).',
        refusal: 'Odmietnutie',
        warning: 'Varovanie',
        generation: 'generácia dokumentu {n}',
        state: {
          manual: 'Ručný',
          derived: 'Odvodený',
          diverged: 'Odchýlený'
        },
        topologyTitle: 'Deklarovaná topológia',
        members: 'členovia',
        primary: 'primárny',
        held: 'držaný na JEDNOM členovi',
        form: {
          perNetworkBond: 'Bond na sieť',
          singleBond: 'Jediný záložný bond',
          laggBond: 'LACP bond (LAGG)',
          singlePort: 'Jediný port'
        },
        colAction: 'Akcia',
        colKind: 'Druh',
        colDevice: 'Device',
        colDetail: 'Detail',
        action: {
          add: 'pridať',
          remove: 'odobrať',
          replace: 'nahradiť'
        },
        diffEmpty: 'Žiadny čakajúci diff — aplikovaný dokument sa zhoduje s renderom.',
        diffBlocked: 'Žiadny diff: odmietnutia vyššie blokujú tento uzol.',
        phasePlanned: 'naplánované (krok 1 z 3)',
        phaseDraining: 'vyprázdňuje sa (krok 2 z 3)',
        probeUnobserved: 'Sonda vyprázdňovania: nikdy nehlásená — prázdnota je NEZNÁMA (retire by bol teraz odmietnutý).',
        probeFailed: 'Sonda vyprázdňovania: pozorovanie ZLYHALO — známe časové značky sa prenášajú, nikdy «prázdno», ktoré nikto nemeral.',
        probeActive: {
          one: 'Sonda: {n} nadviazané spojenie stále na starej adrese',
          few: 'Sonda: {n} nadviazané spojenia stále na starej adrese',
          many: 'Sonda: {n} nadviazaného spojenia stále na starej adrese',
          other: 'Sonda: {n} nadviazaných spojení stále na starej adrese'
        },
        probeLastActive: 'posledná aktivita {time}',
        probeEmpty: {
          one: 'Sonda: prázdno {n} minútu',
          few: 'Sonda: prázdno {n} minúty',
          many: 'Sonda: prázdno {n} minúty',
          other: 'Sonda: prázdno {n} minút'
        },
        probeEmptyUnknown: 'Sonda: prázdno (odkedy, neznáme).',
        impact: '{nics} vNIC a {apps} App na tomto uzle používajú tieto siete: {list}',
        apply: 'Aplikovať na tento uzol',
        applyTitle: 'Aplikovať deriváciu — {node}',
        applyIntro: 'Odvodená konfigurácia prepisuje sieťový dokument uzla {node} ({n} zmien) tými istými dverami ako editor host-network — checkpoint NetworkManagera a poctivá sonda vrátane. Varovania plánu nižšie cestujú s aktom: prečítajte si ich pred potvrdením.',
        applyError: 'Apply zlyhal',
        applyRefused: 'Uzol odmietol:',
        planMoved: 'Fabric sa po tomto náhľade zmenila — NIČ nebolo aplikované. Plán bol znovu načítaný: pozrite sa znova a skúste to znova.',
        retire: 'Vyradiť',
        retireTitle: 'Bod, odkiaľ niet návratu — vyradenie {address}',
        restore: 'Obnoviť',
        restoreTip: 'Späť na snapshot spred apply (generácia {previous}) — undo o jeden krok (H13)',
        restoreTitle: 'Obnoviť predchádzajúci dokument — {node}',
        restoreIntro: 'Sieťový dokument uzla {node} sa vráti k snapshotu urobenému pred posledným apply (generácia {previous}), prepísanému ako generácia {next} namiesto {current}. Worker ho zladí ako každý iný dokument.',
        restoreRedo: 'Nahradený dokument sa stáva novým snapshotom: opätovné obnovenie je redo.',
        restoreClosesChain: 'Snapshot je ručný dokument spred derivácie: reťaz sa tu uzatvára — žiadne ďalšie undo, uzol je ručný až do ďalšieho apply.',
        restoreConfirm: 'Obnoviť',
        restoreError: 'Obnovenie zlyhalo',
        retireIntro: 'Toto odstráni {address} ({network}) z {point} definitívne. Po tomto akte je cestou späť OBRÁTENÝ flip — znovudeklarácia starej adresy tým istým strojom — nikdy slepá obnova.',
        retireOld: 'Stará adresa (odstránená)',
        retireNew: 'Nová adresa (zostáva)',
        retireEmptyFact: 'Sonda vyprázdňovania hlási adresu prázdnu: toto odstránenie nepreruší žiadne pozorované spojenie.',
        retireConfirm: 'Vyradiť adresu',
        severActiveLoss: {
          one: 'Prerušiť {n} nadviazané spojenie stále na starej adrese — umiera s týmto aktom',
          few: 'Prerušiť {n} nadviazané spojenia stále na starej adrese — umierajú s týmto aktom',
          many: 'Prerušiť {n} nadviazaného spojenia stále na starej adrese — umierajú s týmto aktom',
          other: 'Prerušiť {n} nadviazaných spojení stále na starej adrese — umierajú s týmto aktom'
        },
        severUnknownLoss: 'Prijať NEZNÁME: sonda túto adresu nikdy nepozorovala (alebo pozorovanie zlyháva) — živé spojenia môžu byť prerušené.'
      },
      title: 'Fabric',
      createTitle: 'Vytvoriť fabric',
      networks: 'Siete',
      switches: 'Prepínače',
      ports: 'Porty',
      laggs: 'LAGG',
      subnets: 'Podsiete',
      tabOverview: 'Prehľad',
      tabNetworks: 'Logické siete',
      tabSwitches: 'Prepínače',
      overviewHint: 'Sieťová fabric na jeden pohľad: každá logická sieť s MTU a podsieťou (VLAN žijú len v mapovaniach per-port/per-LAGG — tá istá sieť môže na rôznych portoch cestovať s rôznymi tagmi). Fabric je register EXTERNEJ infraštruktúry — TVirt pozoruje a deklaruje, nikdy nerobí provisioning a dotýka sa len NIC registrovaných pod jeho kontrolou.',
      absorptionHint: 'Každá podsieť deklarovaná tu ODVODZUJE svoju položku v registri IPAM v tom istom zápise — žije a umiera so sieťou.',
      scopeFixedHint: 'Scope je pevne daný — koreň klastra: fyzická infraštruktúra je z definície celoklastrová.',
      networksHint: 'Každá sieť nesie povinné MTU (predvolené 1500) a povinnú podsieť; brána, DNS servery a statické trasy deklarované tu sú JEDINÝ ZDROJ pre NIC serverov, App a sieťové služby.',
      switchesHint: 'Manuálny register: port je nepoužitý, mapovaný (untagged prevádzka a prevádzka podľa VLAN tagu na logické siete) alebo člen LAGG — člen nenesie vlastné mapovania.',
      mtu: 'MTU',
      cidr: 'CIDR',
      cidrHint: 'Povinné — IPAM z neho automaticky odvodí položku registra',
      nodeAddressing: 'Adresovanie uzlov',
      nodeAddressingNone: 'Žiadne — bez adresy pre uzol',
      nodeAddressingPool: 'Pool — jedna trvalá adresa pre každý obslúžený uzol',
      nodeAddressingHint: 'S Pool priradí odvodenie fabricu každému obslúženému uzlu adresu z rozsahov vyhradených pre TVirt (po priradení trvalá).',
      backing: 'Backing',
      gateway: 'Brána',
      ranges: 'Rezervované rozsahy',
      dns: 'DNS servery (oddelené čiarkami)',
      dnsShort: 'DNS',
      singleSourceHint: 'Brána, DNS a trasy deklarované tu sú jediný zdroj — NIC serverov, App a sieťové služby čerpajú odtiaľto',
      routesTitle: 'Statické trasy',
      routeDestination: 'Cieľ (CIDR)',
      routeVia: 'Cez (next hop)',
      portUsed: 'Použitý',
      vlanMappings: 'Mapovania VLAN',
      vlanTag: 'VLAN tag',
      vlanNetwork: 'Logická sieť',
      nameTaken: 'Tento názov sa v sieťovej fabric už používa',
      addNetwork: 'Pridať sieť',
      editNetwork: 'Upraviť sieť',
      deleteNetwork: 'Odobrať sieť',
      deleteNetworkConfirm: 'Odobrať logickú sieť {name} zo sieťovej fabric? Jej odvodená podsieť v IPAM umiera s ňou (odmietne sa, kým ju používa nejaká služba alebo App). Mapovania na portoch a LAGG, ktoré na ňu ukazujú, sa odstránia.',
      switchName: 'Prepínač',
      portName: 'Port',
      positionHint: 'Fyzická pozícia (voliteľná) — rovnaký slovník ako umiestnenie serverov; len deklaratívna',
      addSwitch: 'Pridať prepínač',
      editSwitch: 'Upraviť prepínač',
      deleteSwitch: 'Odobrať prepínač',
      deleteSwitchConfirm: 'Odobrať prepínač {name} so všetkými jeho portami? LAGG sa zodpovedajúco zmenšia (a pod dvoma portami zanikajú).',
      addPort: 'Pridať port',
      editPort: 'Upraviť port',
      deletePort: 'Odobrať port',
      deletePortConfirm: 'Odobrať port {name}?',
      untagged: 'Untagged',
      tagged: 'Tagged (tag:sieť)',
      taggedShort: 'Tagged',
      portCabling: 'Kabeláž',
      portState: 'Stav',
      stateUnused: 'nepoužitý',
      stateMapped: 'mapovaný',
      laggPortGuard: 'Port, ktorý je členom LAGG, sa upravuje zo strany LAGG',
      laggsTitle: 'LAGG',
      laggsHint: 'LAGG je 2+ portov v LACP a môže prechádzať cez prepínače (MLAG, transparentne); vstupujú len nepoužité porty, LAGG je plocha mapovania, odobraný port sa vracia medzi nepoužité.',
      addLagg: 'Pridať LAGG',
      editLagg: 'Upraviť LAGG',
      deleteLagg: 'Odobrať LAGG',
      deleteLaggConfirm: 'Odobrať LAGG {name}? Jeho členské porty sa vrátia medzi nepoužité.',
      lacpRate: 'LACP rate',
      laggPorts: 'Členské porty (2+)',
      laggPortsHint: 'Vstupujú len nepoužité porty — mapovaný port najprv uvoľnite',
      noNetworks: 'Nie je deklarovaná žiadna logická sieť.',
      noSwitches: 'Nie je deklarovaný žiadny prepínač.',
      noLaggs: 'Nie je deklarovaný žiadny LAGG.',
      staleConflict: 'Iný operátor zmenil tento fabric, kým si ho upravoval: uloženie bolo odmietnuté, aby sa jeho práca nezmazala. Tvoje zmeny sú stále tu, nedotknuté. Aktualizovaný fabric už bol znovu načítaný: potvrď znova, nech sa použijú navrch, alebo zruš a pozri sa, čo sa zmenilo.'
    },
    ipam: {
      title: 'IPAM',
      derivedHint: 'Len odvodené: každá podsieť vzniká z logickej siete fabric alebo z overlay — upravuje sa pri zdroji. Pridelené adresy ukazujú, KTO ich drží; rozsahy rezervované pre TVirt sú pooly automatického prideľovania.',
      search: 'Hľadať podľa názvu, CIDR alebo adresy',
      empty: 'Žiadne siete — deklarujte logickú sieť fabric alebo overlay podsieť: IPAM sa z nich odvodzuje automaticky.',
      reserved: 'Rozsahy rezervované pre TVirt',
      address: 'Adresa',
      origin: 'Pôvod',
      origin_declared: 'deklarovaná',
      origin_observed: 'pozorovaná',
      holder: 'Držiteľ',
      noAddresses: 'V tejto podsieti nie je známa žiadna adresa.',
      sourceFabric: 'Fabric',
      sourceOverlay: 'Overlay',
      editAtSource: 'Upraviť pri zdroji'
    },
    firewall: {
      title: 'Skupiny firewallu',
      createTitle: 'Nová skupina firewallu',
      editTitle: 'Upraviť skupinu firewallu',
      empty: 'Zatiaľ žiadna skupina firewallu — vytvorte jednu: znovupoužiteľný slovník pravidiel, na ktorý sa hosťovské NIC odkazujú menom.',
      nameHint: 'Písmená, číslice a vnútorné . - _; jedinečné vo svojom scope (rovnomenné skupiny inde sa rozlišujú zápisom /scope/názov)',
      description: 'Popis',
      descriptionHint: 'Jeden riadok zámeru, zobrazený všade, kde sa skupina vyberá',
      enforced: 'Vynútená na scope',
      enforcedHint: 'Vypnuté: čistý slovník — pravidlá viažu len tie NIC, ktoré sa na skupinu odkazujú. Zapnuté: pravidlá viažu každú hosťovskú NIC so zapnutým firewallom pod scope skupiny, s odkazom aj bez neho.',
      enforcedChip: 'Vynútená',
      enforcedChipHint: 'Pravidlá viažu každú hosťovskú NIC so zapnutým firewallom pod scope skupiny, s odkazom aj bez neho',
      enforceWarning: 'Zapnutím vynútenia pravidlá zviažu KAŽDÚ hosťovskú NIC so zapnutým firewallom pod {scope} pri najbližšej konvergencii, aj bez explicitného odkazu — a vnútri zapnutého chainu je drop predka konečný: úrovne nižšie ho znova neotvoria.',
      unenforceInfo: 'Po vypnutí vynútenia zostanú pravidlá len na NIC, ktoré sa na skupinu odkazujú explicitne.',
      rules: 'Pravidlá',
      tabOverview: 'Prehľad',
      tabRules: 'Pravidlá',
      orderHint: 'Poradie riadkov JE poradím vyhodnocovania vnútri skupiny: vyhráva prvé pravidlo, ktoré sa zhodne.',
      statefulHint: 'Stateful je implicitný: odpovede na povolenú prevádzku prechádzajú samy (established/related prijaté, invalid zahodený — vkladá ich engine, ručne sa nepíšu).',
      noRules: 'Žiadne pravidlá — slovník vo výstavbe: odkázať sa naň je dovolené a nič nevykreslí.',
      addRule: 'Pridať pravidlo',
      direction: 'Smer',
      directionIn: 'Prichádzajúci',
      directionOut: 'Odchádzajúci',
      action: 'Akcia',
      action_accept: 'Prijať',
      action_drop: 'Zahodiť',
      action_reject: 'Odmietnuť',
      protocol: 'Protokol',
      protocolAny: 'Akýkoľvek',
      ports: 'Porty',
      source: 'Zdroj',
      dest: 'Cieľ',
      comment: 'Komentár',
      addressHint: 'CIDR IPv4, alebo <fabric>/<logická sieť>; prázdne = čokoľvek',
      moveUp: 'Posunúť vyššie',
      moveDown: 'Posunúť nižšie',
      nicFirewall: 'Firewall',
      nicAntiSpoof: 'Anti-spoofing',
      nicGroups: 'Skupiny firewallu',
      nicGroupsPlaceholder: 'Vyberte skupinu…',
      nicGroupsHint: 'Viditeľné skupiny vrátane tých z nadradených scope (použiteľné smerom nadol, ako tagy)',
      nicGroupCount: { one: '{n} skupina firewallu', few: '{n} skupiny firewallu', many: '{n} skupiny firewallu', other: '{n} skupín firewallu' },
      nicOff: 'Firewall vypnutý',
      pendingRestartHint: 'Zmeny firewallu nasledujú model uložené/aplikované: čakajú na najbližší power cycle (PendingRestart). Skupiny vynútené nadradenými scope platia, keď je firewall NIC zapnutý.',
      appConvergeHint: 'Zmeny firewallu sa prejavia pri najbližšej konvergencii kontajnera. Skupiny vynútené nadradenými scope platia, keď je firewall zapnutý.',
      enforcedAncestors: 'Vynútené nadradenými scope',
      enforcedAncestorsHint: 'Táto skupina sa vzťahuje na každú NIC pod svojím scope so ZAPNUTÝM firewallom — prepínač je hlavný vypínač NIC (vypnuté = žiadny chain, predkov vrátane); vnútri zapnutého chainu je autorita predka konečná: jeho drop sa nižšie znova neotvorí.'
    }
  }
}
